export const StatusTableColumns = [
  {
    Header: "Severity",
    id: "severity",
    accessor: "severity",
    sortable: true,
  },
  {
    Header: "Heartbeat",
    id: "heartbeat",
    accessor: "time",
    sortable: true,
  },
  {
    Header: "Name",
    id: "name",
    accessor: "location.name",
    width: 120,
  },
  {
    Header: "Venue Name",
    id: "venueName",
    accessor: "location.venueName",
    width: 150,
  },
  {
    Header: "Field Short Name",
    id: "fieldShortName",
    accessor: "location.fieldShortName",
    width: 120,
    minWidth: 120,
  },
  {
    Header: "Field Name",
    id: "fieldName",
    accessor: "location.fieldName",
    width: 150,
  },
  {
    Header: "IP Address",
    id: "ipAddress",
    accessor: "publicNetworkInformation.ipAddress",
    width: 100,
  },
  {
    Header: "PTU Connected",
    id: "ptuConnected",
    accessor: "connectedPtu.isConnected",
    sortable: true,
  },
  {
    Header: "PTU Serialnumber",
    id: "ptuSerialnumber",
    accessor: "connectedPtu.serialNumber",
    width: 120,
  },
  {
    Header: "Server Provisioned",
    id: "serverProvisioned",
    accessor: "createdByHbcp",
    sortable: true,
  },
  {
    Header: "System ID",
    accessor: "systemId",
    width: 150,
  },
  {
    Header: "RAM",
    id: "ram",
    accessor: "statusAlerts.hostOutOfMemory",
    width: 55,
  },
  {
    Header: "HDD",
    id: "hdd",
    accessor: "statusAlerts.hostOutOfDiskSpace",
    // disableResizing: true,
    width: 55,
  },
  {
    Header: "CPU",
    id: "cpu",
    accessor: "statusAlerts.hostHighCpuLoad",
    // disableResizing: true,
    width: 55,
  },
  {
    Header: "Uploading Data",
    id: "uploadingData",
    accessor: "statusAlerts.systemNotUploadingData",
    // disableResizing: true,
    width: 100,
  },
];
